import React from "react";

import { Button, Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { PageListBean, RestReadRequest } from "../ds/ds.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  EditableDataGrid,
  InputTextbox,
  MultiViewPopup,
} from "../gui_components/UIComponents.js";
import { PopupFabricModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { ReportService } from "../services/ReportService.js";
import { ModuleToolBar } from "./BaseModule.js";
class WebfabricImportCriteriaView extends React.Component {
  constructor(props) {
    super(props);
  }
  loadExcel = (e) => {
    if (e.detail === 1) {
      const input = document.getElementById("file-input");

      if (input) {
        input.click();
      }
    }
  };
  uploadExcelFile = (e) => {
    this.props.uploadExcelFile(e);
  };
  render() {
    return (
      <div>
        <Row>
          <Col sm="2">
            <FormLabel>Select Input File</FormLabel>{" "}
          </Col>
          <Col sm="3">
            <Button
              id="fabric_Add_Button"
              size="sm"
              onClick={(e) => this.loadExcel(e)}
            >
              Choose File
            </Button>
            <input
              type="file"
              id="file-input"
              style={{ display: "none" }}
              onChange={this.uploadExcelFile}
              accept=".doc,.docx,application/pdf,.xlsx, .xls, .csv,.txt"
            />
          </Col>
        </Row>
      </div>
    );
  }
}
class WebfabricImportResultPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowFabricModule: false,
    };
  }

  onFabricClick = (val) => {
    if (val !== "" && val !== undefined) {
      this.setState({
        isShowFabricModule: true,
        moduleForPopup: (
          <PopupFabricModule
            fabricStyleCode={val}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  fabricDataDefinition = () => {
    let data = [];

    data.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Item" : "FabricStyle#",
        "code",
        0,
        true,
        this.onFabricClick,
        false,
        null,
        "10em", //min-width
        "15%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Item" : "FabricStyle#",
        "code",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "15%" //max-width
      )
    );

    data.push(
      new DataGridColumnDefinition().setDetails(
        this.props.is3PL ? "Item Name" : "FabricStyle Name#",
        "description",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "15%" //max-width
      )
    );

    data.push(
      new DataGridColumnDefinition().setDetails(
        "Product Type",
        "productTypeCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "95%" //max-width
      )
    );

    data.push(
      new DataGridColumnDefinition().setDetails(
        "Currency",
        "currencyCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Category",
        "categoryCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Sub Category",
        "subCategoryCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Season",
        "seasonCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Default WH",
        "defaultLocationCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Inv UOM",
        "inventoryUomCode",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Cost",
        "cost",
        1,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "RetailPrice",
        "retailPrice",
        1,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "WholesalePrice",
        "wholesalePrice",
        1,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    data.push(
      new DataGridColumnDefinition().setDetails(
        "Desc",
        "description",
        0,
        false,
        null,
        false,
        null,
        "8em", //min-width
        "10%" //max-width
      )
    );
    return data;
  };
  lnkFabricModule = () => {
    let purchaseOrderLineData = this.props.purchaseOrderLineData;
    let code = purchaseOrderLineData.fabricStyleCode;
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowFabricModule: true,
        moduleForPopup: (
          <PopupFabricModule
            fabricStyleCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({ isShowFabricModule: isOpen, moduleForPopup: [] });
  };
  render() {
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
          width: "100%",
        },
      },
      table: {
        style: {
          minHeight: "auto",
          maxHeight: "auto",
          overflowY: "auto",
          width: "100%",
        },
      },
    };
    let datas = this.props.webfabricImportResltBean.fabricStyleList;
    let webfabricData = this.props.webfabricImportResltBean;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.state.isShowFabricModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <Row>
          <Col className="align-items-left" sm="2">
            <FormLabel>No of Updated Items</FormLabel>{" "}
          </Col>

          <Col sm="2">
            <InputTextbox
              name="updatedFabricStyleCount"
              placeholder="BankCode"
              value={webfabricData.updatedFabricStyleCount}
              showCriteriaDialog={true}
              disabled={true}
            />
          </Col>
        </Row>
        <Row>
          <EditableDataGrid
            customStyles={dataTableStyles}
            columnsList={this.fabricDataDefinition()}
            dataList={datas}
          />
        </Row>
      </div>
    );
  }
}
class WebfabricImportList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "Web fabric Import",
      webFabricImport_list: new Array(),
      companyCode: "",
      pageList: new PageListBean(),
      isLoading: false,
      // criteria: new DepositSearchCriteria(),
      // depositData: new DepositBean(),

      currentPageNumber: 0,
      totalCount: 0,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      isAdvanceSearch: false,

      isSpecialViewMode: false,
      moduleKeyCode: "NEW",
      isShowModuleSearchContainer: false,
      isWebfabricImportCriteriaViewOpen: true,
      isWebfabricImportListFormOpen: false,
      isResetView: true,
      isFocusLookup: true,
      isFocus: false,
      isResetModule: false,
      isShowWebFabricImportResultPage: false,
      webfabricImportResltBean: null,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      is3PL: false,
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    if (this.state.is3PL === true) {
      this.state.pageTitle = "Web Item Import";
    } else {
      this.state.pageTitle = "Web fabric Import";
    }
  }
  uploadExcelFile = (e) => {
    this.hideAlertCallBack(false);
    let file = e.target.files[0];

    let fileName = file.name;
    let fileData = new File([file], `${fileName}`, { type: file.type });
    let formData = new FormData();
    formData.append("file", fileData);

    this.setState({ fileName: fileName });
    if (SecurityAccessManager.WebItemImport_IsAccessible()) {
      FabricStyleService.webFabricDataInputExcelUpload(
        formData,
        this.uploadExcelResponse,
        this.uploadExcelError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  uploadExcelResponse = (response) => {
    if (response.data != null) {
      if (response.data.success == true) {
        this.getExcelData();
      }
    }
  };
  uploadExcelError = (error) => {
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  getExcelData = () => {
    this.setState({
      isLoading: true,
      loadingText: "Loading Excel Data",
    });

    let listRequest = new RestReadRequest();
    listRequest.companyCode = this.companyCode;
    listRequest.code = this.state.fileName;
    if (SecurityAccessManager.WebItemImport_IsAccessible()) {
      ReportService.getInputWebFabricDataExportFromExcel(
        listRequest,
        this.getExcelDataResponse,
        this.getExcelDataError
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  getExcelDataResponse = (response) => {
    let webfabricImportResltBean = response.data.resultBean;
    if (webfabricImportResltBean != null) {
      this.setState({
        webfabricImportResltBean: webfabricImportResltBean,
        isLoading: false,
      });

      this.openWebFabricImportResultPage();
    } else {
      let errMsg = "No data Found";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
      });
    }
  };
  getExcelDataError = (error) => {};
  openWebFabricImportResultPage = () => {
    this.setState({
      isShowWebFabricImportResultPage: true,
      isWebfabricImportCriteriaViewOpen: false,
    });
  };
  closeWebFabricImportResultPage = () => {
    this.setState({
      isShowWebFabricImportResultPage: false,
      isWebfabricImportCriteriaViewOpen: true,
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  resetView = () => {
    this.closeWebFabricImportResultPage();
    this.setState({
      webfabricImportResltBean: null,
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  render() {
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {/* {this.state.isWebfabricImportCriteriaViewOpen && ( */}
        <ModuleToolBar
          isMaintenanceMode={false}
          isSpecialViewMode={true}
          onModuleExit={() => this.moduleExit()}
          resetView={() => this.resetView()}
          pageTitle={this.state.pageTitle}
          loadingText={this.state.loadingText}
          isLoading={this.state.isLoading}
          isResetView={this.state.isResetView}
        />

        {this.state.isWebfabricImportCriteriaViewOpen && (
          <WebfabricImportCriteriaView
            uploadExcelFile={this.uploadExcelFile}
            loadExcel={this.loadExcel}
          />
        )}
        {this.state.isShowWebFabricImportResultPage && (
          <WebfabricImportResultPage {...this.state} />
        )}
      </div>
    );
  }
}

function WebItemImportModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <WebfabricImportList {...props} name="" /> <br />
      </div>
    </div>
  );
}
export default WebItemImportModule;
